import { cn } from '@packages/shared/src/utils/cn/cn';
import type { ReactNode, MouseEvent, KeyboardEvent } from 'react';

export type LinearSuggestionsItemProps = {
  children: ReactNode;
  className?: string;
  onClick?: (event: MouseEvent<HTMLLIElement>) => void;
  onKeyDown?: (event: KeyboardEvent<HTMLLIElement>) => void;
};

export const LinearSuggestionsItem = ({
  children,
  className,
  onClick,
  onKeyDown,
}: LinearSuggestionsItemProps) => (
  <li
    role="menuitem"
    className={cn(
      'hover:bg-color-grey-light flex min-h-[42px] items-center justify-between py-0 pr-0 pl-6',
      className,
    )}
    onClick={onClick}
    onKeyDown={onKeyDown}
  >
    {children}
  </li>
);
